import { useCallback, useState } from "react";
import handleApiError from "../../hooks/handleApiError";
import client from "../client";
import { handleToast } from "../../utils/functions";

export default function useCreateScorecard() {
  const [loading, setLoading] = useState(false);

  const request = useCallback(async (payload) => {
    try {
      const { data } = await client.post(
        `/result/reportcard/scorecard/add`,
        payload
      );

      handleToast(data?.message);
      setLoading(false);
      return true;
    } catch (error) {
      setLoading(false);
      handleApiError(error);
    }
  }, []);

  return [request, loading];
}
